import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

/**
 * A line in two parts, so that a long lead is cut short and the trail after it is not: a work's
 * name and its version, "10/13 Test" and " · v2". Give it the line's `variant` and color, the lead
 * to `KeptTrailLead`, and the trail, separator included, to `KeptTrail`.
 *
 * Cut from the end, the line lost the version first, and two rows for v1 and v2 of one work then
 * read the same. An inline caption was worse, where `noWrap` draws no ellipsis at all and the text
 * ran on under whatever followed it (#6809).
 */
export const KeptTrailLine = styled(Typography)({ display: "flex", minWidth: 0 });
export const KeptTrailLead = styled("span")({
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});
export const KeptTrail = styled("span")({ flexShrink: 0, whiteSpace: "pre" });
